module.exports = __webpack_public_path__ + "b12a978714796f7e569789b59756d57e.png";